export default function NotFound() {
  return (
    <div className="w-full h-full flex items-center justify-center">
      <p className="font-manrope text-[20px] font-medium text-primary">
        Page Not Found
      </p>
    </div>
  );
}
